<mat-dialog-content>
  <div class="container-fluid p-3">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center">
        <div class="message-symbol" *ngIf="data.symbol">
          <ion-icon
            [name]="data.symbol"
            [style.color]="data.color"
            class="message-icon me-2"
          ></ion-icon>
        </div>
        <h3 class="mb-0 fw-bold">{{ data.headline }}</h3>
      </div>
      <small class="text-muted">{{ data.publishDate | customDate }}</small>
    </div>

    <div style="max-height: 300px; overflow-y: auto; white-space: pre-wrap">
      {{ data.text }}
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    class="btn btn-success mt-3"
    style="margin: auto; display: block; width: 20%"
    (click)="closeDialog()"
  >
    Done
  </button>
</mat-dialog-actions>
